import { HStack, VStack, Text, Box, Image, IconButton } from "@chakra-ui/react";
import { FaPlus, FaMinus } from "react-icons/fa";
import { KYDEventStatus } from "@common/interfaces/KYDEvent";
import { badgeForStatus } from "../../Events/EventsTable";

const EventCard = ({
  isSelected,
  name,
  image,
  venueName,
  address,
  startAt,
  link,
  onAdd,
  onRemove,
  status,
}: {
  isSelected?: boolean;
  name: string;
  image: string;
  venueName: string;
  address: string;
  startAt: string;
  link: string;
  onAdd: () => void;
  onRemove: () => void;
  status?: KYDEventStatus;
}) => {
  return (
    <HStack
      w="full"
      borderRadius={8}
      boxShadow={"xs"}
      p={2}
      background={isSelected ? "gray.100" : "inherit"}
    >
      <HStack w="full" spacing={2} flexShrink={1} maxW={"80%"}>
        <Box
          flexShrink={0}
          h="100px"
          w="100px"
          alignItems={"flex-start"}
          overflow={"hidden"}
        >
          <Image
            rounded="md"
            background="gray.200"
            src={image}
            w="100%"
            h="100%"
            objectFit={"cover"}
          />
        </Box>
        <VStack
          w="full"
          spacing={0}
          justifyContent={"start"}
          alignItems={"start"}
        >
          <Text w="full" fontWeight={"bold"} noOfLines={1} cursor={"pointer"}>
            <a href={link} target="_blank">
              {name}
            </a>
          </Text>
          <Text fontSize={"xs"} w="full" noOfLines={1}>
            {venueName} {address}
          </Text>
          <Text w="full" fontSize={"xs"}>
            {startAt}
          </Text>
          {status ? badgeForStatus(status) : ""}
        </VStack>
      </HStack>
      <Box
        minW="64px"
        flexShrink={0}
        justifySelf={"flex-end"}
        display={"flex"}
        justifyContent={"flex-end"}
        pr={3}
      >
        <IconButton
          variant={"outline"}
          aria-label="Toggle event in bundle"
          icon={isSelected ? <FaMinus /> : <FaPlus />}
          onClick={() => {
            isSelected ? onRemove() : onAdd();
          }}
        />
      </Box>
    </HStack>
  );
};

export default EventCard;
